<template>
    <div class="RiskProfileAssignmentHeader">
        <div class="RiskProfileAssignmentHeader__title">
            <strong>Assignment Rules:</strong>
            <span class="ml-1 mr-1 text-eidDangerRed">*</span>
            <div
                v-if="shouldShowError"
                class="text-eidDangerRed flex items-center"
            >
                <FontAwesomeIcon
                    class="ml-3 mr-1"
                    :icon="faExclamationTriangle"
                />
                <span>Required</span>
            </div>
        </div>
        <div
            v-if="shouldShowError"
            class="RiskProfileAssignmentHeader__error text-eidDangerRed"
        >
            <span>{{ errorMsg }}</span>
        </div>
    </div>
</template>
<style lang="scss">
.RiskProfileAssignmentHeader {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid var(--eidTechGray-25);

    &__title {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
    }

    &__error {
        margin-bottom: 8px;
    }
}
</style>
<script lang="ts">
    import { Component, Prop, Vue } from '@evidentid/vue-property-decorator';

    import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    @Component({
        components: { FontAwesomeIcon },
    })
    export default class RiskProfileAssignmentHeader extends Vue {
        @Prop({ type: Boolean, required: true })
        private shouldShowError!: boolean;

        @Prop({ type: String, required: false, default: '' })
        private errorMsg!: string | null;

        private faExclamationTriangle = faExclamationTriangle;
    }
</script>
